import { makePath } from './routes';

export const getDefaultRoute = (workspaceId: string, tab?: string | null) => {
  const defaultTab = 'projects';
  const [path, search] = (tab ?? defaultTab).split('?');
  return makePath(['w', workspaceId, ...path.split('/')], {
    searchParams: new URLSearchParams(search),
  });
};
